import Vue from 'vue'
import Router from 'vue-router'
import Start from '@/components/endpoints/Start'
import Page from '@/components/endpoints/Page'
import Therapie from '@/components/endpoints/Therapie'
import Kurs from '@/components/endpoints/Kurs'
import Leistungen from '@/components/endpoints/Leistungen'
import Kurse from '@/components/endpoints/Kurse'
import App from '@/App'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/kurse/:slug',
            name: 'Kurs',
            component: Kurs,
            meta: {}
        },
        {
            path: '/leistungen/:slug',
            name: 'Therapie',
            component: Therapie,
            meta: {}
        },
        {
            path: '/:dir/:slug',
            name: 'SubPage',
            component: Page,
            meta: {}
        },
        {
            path: '/leistungen',
            name: 'Leistungen',
            component: Leistungen,
            meta: {}
        },
        {
            path: '/kurse',
            name: 'Kurse',
            component: Kurse,
            meta: {}
        },
        {
            path: '/:slug',
            name: 'Page',
            component: Page,
            meta: {}
        },
        {
            path: '/',
            name: 'Start',
            component: Start,
            meta: {'slug': 'start'}
        },

    ],
    mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash',
})



// WEBPACK FOOTER //
// ./src/router/index.js